import React, { Component } from 'react';
import '../../../src/styles/ShoppingCart.css';
import '../../../src/styles/open-iconic.css';
import '../../../src/styles/open-iconic-bootstrap.css';
import { userService } from '../../_services';
import queryString from 'query-string';
import DocumentMeta from 'react-document-meta';
import { Redirect, Route } from 'react-router-dom';

export class SetPassword extends Component {
    displayName = SetPassword.name

    constructor(props) {
        super(props);
        this.state = {
            user: {                
                newpassword: '',
                cnfmpassword: ''
            },
            errors: {},
            message: "",
            submitted: false,
            redirectToLogin: false
        };
        this.handleChange = this.handleChange.bind(this);      
        this.handleConfirmPwd = this.handleConfirmPwd.bind(this);
        this.handleResetPwd = this.handleResetPwd.bind(this);
    }

    validateForm() {

        let fields = this.state.user;
        let errors = {};
        let formIsValid = true;
               

        if (!fields["newpassword"]) {
            formIsValid = false;
            errors["newpassword"] = "Please enter your new secure password.";
        }
        else if (typeof fields["newpassword"] !== "undefined") {
            if (!fields["newpassword"].match(/^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*()+-]).*$/)) {
                formIsValid = false;
                errors["newpassword"] = "Please enter secure and strong password. Password must be 8 characters long and contain one capital, one small, one numeric and one special character(~!@#$%^&*()-+)";
            }
        }       

        if (!fields["cnfmpassword"]) {
            formIsValid = false;
            errors["cnfmpassword"] = "Please enter confirm password.";
        }

        if (fields["cnfmpassword"] != fields["newpassword"]) {
            formIsValid = false;
            errors["cnfmpassword"] = "New password and confirm password does not match.";
        }

        if (typeof fields["cnfmpassword"] !== "undefined") {
                if (!fields["cnfmpassword"].match(/^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*()+-]).*$/)) {
                    formIsValid = false;
                    errors["cnfmpassword"] = "Please enter secure and strong confirm password. Password must be 8 characters long and contain one capital, one small, one numeric and one special character(~!@#$%^&*()-+)";
                }
            }

            this.setState({
                errors: errors
            });
            return formIsValid;
        }

    handleConfirmPwd(evt) {
            let errors = {};
            if (evt.target.value != this.state.newpassword) {                
                errors["cnfmpassword"] = "New password and Confirm password should match.";                
            }
            else {
                errors["cnfmpassword"] = "";                
        }
        //this.setState({  errors: errors});
    }

    handleResetPwd(evt) {

        if (this.validateForm()) {

            var url = this.props.location.search;
            var params = queryString.parse(url);

            var parameters = {
                ResetKey: params.key,
                Password: this.state.user["newpassword"]
            }
            
            var self = this;
            userService.postData('User/ResetPassword', parameters)
                .then(function (data) {                    
                    self.setState({ message: data });
                    //alert(data);
                    if (data == "Password Reset successfully") {
                        alert("Password set successfully");
                        self.setState({ redirectToLogin: true });
                    }
                    if (data != "") {                       
                        self.setState({
                            user: {                                
                                newpassword: '',
                                cnfmpassword: ''
                            }
                        });
                    }
                });           
        }
        
    }

    handleChange(event) {        
        const { name, value } = event.target;
        const { user } = this.state;
        this.setState({
            user: {
                ...user,
                [name]: value
            }
        });
    }
                 
    render() {
        const meta = {
            title: "Kluwer Law Online - Set password",
            canonical: window.location.href,
        }

        if (this.state.redirectToLogin) {

            return <Redirect to={"/Login"} />
        }

        const { user, submitted } = this.state;
        return (
            <DocumentMeta {...meta}>

            <div className="col-12 klo-shopshopping-cart">
                <div className="row">
                    <div className="col-lg-12 colPadding margintop">
                        <div id="yourDetails" className="mt-3" >                           
                            <div className="col-sm-12 row">
                                <div className="col">
                                    <div className="row">
                                        <form style={{width:'55%'}}>
                                            <h4 className="my-3 green-heading" style={{ fontSize: '17px' }}>Set Password</h4>
                                           
                                            <div className="form-group mt-3 col-6 px-0">
                                                <label for="newpassword">New Password</label>
                                                <input type="password" className="form-control form-control-sm rounded-0" placeholder="New Password" id="newpassword" name="newpassword" value={user.newpassword} onChange={this.handleChange} />
                                                <div className="errorMsg">{this.state.errors.newpassword}</div>
                                            </div>
                                            <div className="form-group mt-3 col-6 px-0">
                                                <label for="cnfmpassword">Confirm Password</label>
                                                <input type="password" className="form-control form-control-sm rounded-0" placeholder="Confirm Password" id="cnfmpassword" name="cnfmpassword" value={user.cnfmpassword} onChange={this.handleChange} />
                                                <div className="errorMsg">{this.state.errors.cnfmpassword}</div>
                                            </div>                                            
                                            <br/>                                           
                                            <br></br>
                                        </form>
                                    </div>
                                    <div className="row">
                                        <button type="button" className="btn next rounded-0" onClick={this.handleResetPwd} >Set Password</button>
                                    </div>
                                </div>

                                <div className="col-0 border-right"> </div>
                                
                            </div>
                            <div className="col-lg-12 row mb-5 mt-3 ">
                                
                                <div className="col colPadding">
                                    <img src="//klitag.scholarlyiq.com/siqpagetag.gif?js=0" height="1" width="1" border="0" hspace="0" vspace="0" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
                </DocumentMeta>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Login/SetPassword.jsx